/* ============================================================
   FC Finn Cotton — Faster, subtler page navigation
   1) Link prefetching: same-origin pages are prefetched on hover
      (desktop) or touch-start (mobile) so the click feels instant.
   2) Slim top progress bar shown during the residual wait,
      replacing the theme's full-screen "Loading" splash.
   Vanilla JS, no dependencies. Self-contained.
============================================================ */
(function () {
  'use strict';
  if (window.__fcNav) return;
  window.__fcNav = true;

  var doc = document;
  var root = doc.documentElement;

  /* ---------------- Top progress bar ---------------- */
  var bar;

  function ensureBar() {
    if (bar) return bar;
    bar = doc.createElement('div');
    bar.className = 'fc-progress';
    (doc.body || root).appendChild(bar);
    return bar;
  }

  function startBar() {
    ensureBar();
    // Restart the trickle from 0 even on repeat triggers.
    root.classList.remove('fc-nav-loading');
    void bar.offsetWidth; // force reflow
    root.classList.add('fc-nav-loading');
  }

  function resetBar() {
    root.classList.remove('fc-nav-loading');
    if (bar) { bar.style.width = ''; }
  }

  if (doc.body) { ensureBar(); }
  else { doc.addEventListener('DOMContentLoaded', ensureBar); }

  // Any real navigation (link, form, JS redirect, checkout) fires unload.
  window.addEventListener('beforeunload', startBar);
  window.addEventListener('pagehide', startBar);
  // Returning via the back/forward cache: clear the leftover bar.
  window.addEventListener('pageshow', function (e) { if (e.persisted) resetBar(); });

  /* ---------------- Prefetch on intent ---------------- */
  var supportsPrefetch = (function () {
    var l = doc.createElement('link');
    return !!(l.relList && l.relList.supports && l.relList.supports('prefetch'));
  })();
  var conn = navigator.connection;
  var saveData = !!(conn && (conn.saveData || /(^|-)2g$/.test(conn.effectiveType || '')));
  var prefetchOn = supportsPrefetch && !saveData;

  var seen = {};
  // Never prefetch state-changing or irrelevant endpoints.
  var DENY_PATH = /\/(cart|checkout|account\/logout|admin|apps|services|tools)(\/|$|\?|#|$)/i;
  var DENY_QUERY = /[?&](logout|add|remove|update|return_to)=/i;

  function eligible(a) {
    if (!a || !a.href) return false;
    if (a.protocol !== 'http:' && a.protocol !== 'https:') return false;
    if (a.origin !== location.origin) return false;
    if (a.hasAttribute('download')) return false;
    var target = (a.getAttribute('target') || '').toLowerCase();
    if (target === '_blank') return false;
    if (a.hasAttribute('data-no-prefetch') || a.hasAttribute('data-no-instant')) return false;
    if ((a.getAttribute('rel') || '').toLowerCase().indexOf('nofollow') > -1) return false;
    // Same page (incl. in-page anchors)
    if (a.pathname === location.pathname && a.search === location.search) return false;
    if (DENY_PATH.test(a.pathname) || DENY_QUERY.test(a.search)) return false;
    if (seen[a.href]) return false;
    return true;
  }

  function prefetch(href) {
    if (seen[href]) return;
    seen[href] = true;
    var l = doc.createElement('link');
    l.rel = 'prefetch';
    l.as = 'document';
    l.href = href;
    doc.head.appendChild(l);
  }

  function anchorFrom(node) {
    while (node && node.nodeName !== 'A') { node = node.parentNode; }
    return node;
  }

  if (prefetchOn) {
    var hoverTimer;

    // Desktop: prefetch after a brief hover (intent), cancel if they leave.
    doc.addEventListener('mouseover', function (e) {
      var a = anchorFrom(e.target);
      if (!eligible(a)) return;
      var href = a.href;
      clearTimeout(hoverTimer);
      hoverTimer = setTimeout(function () { prefetch(href); }, 65);
      a.addEventListener('mouseout', function out() {
        clearTimeout(hoverTimer);
        a.removeEventListener('mouseout', out);
      });
    }, { capture: true, passive: true });

    // Mobile: the tap-down gives ~100ms head start before the click lands.
    doc.addEventListener('touchstart', function (e) {
      var a = anchorFrom(e.target);
      if (eligible(a)) { prefetch(a.href); }
    }, { capture: true, passive: true });
  }
})();
